import React from 'react';
import { SitecoreImageField, SitecoreLinkField } from 'components/sitecore-fields';
import { isEmpty } from 'lodash';
import { getParameterByName } from '../../../../general/js/utils';
import { QueryConstants } from '../../../../general/js/utils/query-constants';

class MastercardRegistrationSuccess extends React.Component {
    constructor(props) {
        super(props);

        this.getButtonLink = this.getButtonLink.bind(this);
    }

    getButtonLink() {
        const { masterCardRegistrationSuccessCTALink } = this.props;
        const redirectUrl = getParameterByName(QueryConstants.REDIRECT_URL);
        const link = !isEmpty(redirectUrl) ? redirectUrl + window.location.hash : window.location.href;
        const buttonLink = link != null ? link : masterCardRegistrationSuccessCTALink.url;
        masterCardRegistrationSuccessCTALink.url = buttonLink;

        return masterCardRegistrationSuccessCTALink;
    }

    render() {
        const {
            masterCardText,
            masterCardLogo,
            masterCardRegistrationSuccessTitle,
            masterCardRegistrationSuccessLabel,
            masterCardRegistrationSuccessDescription,
            firstName
        } = this.props;

        const buttonLink = this.getButtonLink();

        return (
            <div className="mastercard-success">
                <div className="mastercard-success__popup-styling" />
                <div className="mastercard-registration__wrap">
                    <div className="mastercard-success__media">
                        <div className="mastercard-success__media--wrapper" />
                    </div>
                    <div className="mastercard-registration__content">
                        <div className="mastercard-registration__head mastercard-branding-right">
                            <div className='mastercard-branding'>
                                <div className='mastercard-branding--title'>{masterCardText}</div>
                                <SitecoreImageField img={masterCardLogo} className='mastercard-branding--logo' />
                            </div>
                        </div>

                        <div className="mastercard-registration__wrapper">
                            <div className="mastercard-registration__tag">{masterCardRegistrationSuccessLabel}</div>
                            <div className="mastercard-registration__heading">
                                <h2 className="mastercard-registration__title">{masterCardRegistrationSuccessTitle + ' ' + firstName}</h2>
                            </div>
                            <div className="mastercard-registration__form">
                                <div className="mastercard-registration__form--row">
                                    <div className="mastercard-registration__form--text" dangerouslySetInnerHTML={{ __html: masterCardRegistrationSuccessDescription }}></div>
                                </div>
                                <div className="mastercard-registration__form--row">
                                    <SitecoreLinkField className="button button--primary" link={buttonLink} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MastercardRegistrationSuccess;
